module.exports = __webpack_public_path__ + "img/staple-food.1f71861a.svg";